import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

const STATUS_TAG = {
  enquiry:  'ak-tag ak-tag--warn',
  live:     'ak-tag ak-tag--live',
  paused:   'ak-tag',
  complete: 'ak-tag ak-tag--live',
}

const formatDate = (iso) => {
  if (!iso) return '—'
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}

const COLS = '120px 1fr 90px 1fr 120px'

export default function QuotesList({ session }) {
  const navigate = useNavigate()
  const [quotes, setQuotes] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const load = async () => {
      const { data } = await supabase
        .from('quotes')
        .select('id, project_id, quote_ref, date_issued, description, created_at, projects(name, status)')
        .eq('user_id', session.user.id)
        .order('date_issued', { ascending: false })
      setQuotes(data || [])
      setLoading(false)
    }
    load()
  }, [session.user.id])

  if (loading) return (
    <div className="ak-app" style={{ paddingTop: '4rem', textAlign: 'center' }}>
      <span className="t-label">Loading…</span>
    </div>
  )

  return (
    <div className="ak-app">
      <div className="ak-page-head">
        <h1 className="t-page">Quotes</h1>
      </div>

      {quotes.length === 0 ? (
        <div style={{ paddingTop: '4rem', textAlign: 'center' }}>
          <p style={{ marginBottom: '0.5rem' }} className="t-label">No quotes yet.</p>
          <p className="t-label" style={{ color: 'var(--ink-3)', fontWeight: 500, textTransform: 'none', letterSpacing: 0 }}>
            Quotes are created from within a project — open a project and click Quote.
          </p>
        </div>
      ) : (
        <div className="ak-card">
          <div className="ak-table-head" style={{ '--cols': COLS }}>
            <span>Ref</span>
            <span>Project</span>
            <span>Status</span>
            <span>Description</span>
            <span className="r">Date</span>
          </div>
          {quotes.map(q => (
            <div
              key={q.id}
              className="ak-row"
              style={{ '--cols': COLS, cursor: 'pointer' }}
              onClick={() => navigate(`/projects/${q.project_id}/quote`)}
            >
              <span className="ak-cell-name">{q.quote_ref || <span style={{ color: 'var(--ink-3)' }}>—</span>}</span>
              <span className="ak-cell-name">{q.projects?.name || <span style={{ color: 'var(--ink-3)' }}>—</span>}</span>
              <span>
                {STATUS_TAG[q.projects?.status]
                  ? <span className={STATUS_TAG[q.projects.status]}>{q.projects.status}</span>
                  : <span style={{ color: 'var(--ink-3)' }}>—</span>}
              </span>
              <span style={{ fontSize: '13px', color: 'var(--ink-2)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {q.description || <span style={{ color: 'var(--ink-3)' }}>—</span>}
              </span>
              <span className="ak-num" style={{ whiteSpace: 'nowrap' }}>{formatDate(q.date_issued)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
